const map = {
	"./404.svg": 7585,
	"./add_to_slack.png": 2473,
	"./background.png": 3495,
	"./clients-1-logo.png": 8033,
	"./clients-2-logo.png": 1820,
	"./feature-1-icon.png": 9481,
	"./feature-2-icon.png": 3476,
	"./feature-3-icon.png": 2551,
	"./feature-4-icon.png": 9162,
	"./hero-bg-2.png": 9462,
	"./holiday.png": 5183,
	"./how-it-works-1.png": 7372,
	"./how-it-works-2.png": 8055,
	"./how-it-works-3.png": 2270,
	"./how-it-works-4.png": 6833,
	"./how-it-works-5.png": 8440,
	"./how-it-works-6.png": 6771,
	"./how-it-works-7.png": 6938,
	"./how-it-works-8.png": 9821,
	"./how-it-works.png": 9814,
	"./icons/search.svg": 490,
	"./icons/user.svg": 1755,
	"./loader.gif": 7049,
	"./loading.svg": 9097,
	"./logo-dark.svg": 3067,
	"./logo-white.svg": 7270,
	"./logo-with-caption-white.png": 924,
	"./marketing-video.png": 7189,
	"./no-image.png": 7098,
	"./policy.png": 6525,
	"./profile.svg": 2198,
	"./profilePicture.png": 8744,
	"./schedule.png": 2604,
	"./scsh_1.png": 9844,
	"./scsh_2.png": 1311,
	"./scsh_3.png": 9766,
	"./scsh_4.png": 2185,
	"./scsh_5.png": 5936,
	"./scsh_6.png": 9755,
	"./scsh_7.png": 9250,
	"./scsh_8.png": 629,
	"./settings.svg": 4756,
	"./slack-2.png": 1430,
	"./slack.png": 5339,
	"./team.png": 9880,
	"./toffy_admin_color.png": 3879,
	"./toffy_ai.png": 3478,
	"./video_bg.png": 2798
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;